import { initVueApp } from '../lib/utils/vue3compat/init_vue_app.js?vue3';
import createStore from '../code_navigation/store/index.js?vue3';
import { pinia } from '../pinia/instance.js?vue3';
import apolloProvider from './graphql.js?vue3';
import RepositoryApp from './components/app.vue?vue3';
import projectPathQuery from './queries/project_path.query.graphql';
import projectShortPathQuery from './queries/project_short_path.query.graphql';
import refsQuery from './queries/ref.query.graphql';
import createRouter from './router.js?vue3';
import { parseRepositoryAppDataset } from './utils/parse_repository_app_dataset';
import { createHighlightWorker } from './utils/highlight_worker_utils';

// Mounts the single repository layout root on `#js-repository-app`, returning
// the same shape as `initRepositoryPage()` for the EE wrappers.
export default function initRepositoryApp(el) {
  const { dataset } = el;
  const { projectPath, projectShortPath, fullName, ref, escapedRef, props, provide } =
    parseRepositoryAppDataset(dataset);

  // The route patterns embed encoded variants of the base ref, so the base
  // must be the pre-encoded ref; a raw ref containing '#' or '%' double-encodes.
  const router = createRouter(projectPath, escapedRef, fullName);

  const { cache } = apolloProvider.clients.defaultClient;
  cache.writeQuery({ query: projectPathQuery, data: { projectPath } });
  if (projectShortPath) {
    cache.writeQuery({ query: projectShortPathQuery, data: { projectShortPath } });
  }
  cache.writeQuery({ query: refsQuery, data: { ref, escapedRef } });

  initVueApp({
    el,
    name: 'RepositoryAppRoot',
    store: createStore(),
    pinia,
    router,
    apolloProvider,
    provide: { ...provide, highlightWorker: createHighlightWorker() },
    component: RepositoryApp,
    props,
  });

  return { router, data: dataset, apolloProvider, projectPath };
}
